module.exports = __webpack_public_path__ + "img/abkhazia.fa0ba910.svg";